export const accordionDataAyuda = [
  {
    title: '¿Qué son los planes Libre, Básico y Full y cuáles son las diferencias?',
    content: `<p>La diferencia entre los planes son la cantidad de dispositivos en los que puedes usar XDNeo en forma simultánea. En el Plan Básico cuentas con 2 dispositivos mientras que en el Full cuentas con 4 dispositivos a la vez. </p>
    <p>En ambos planes tienes más de 100 canales locales e internacionales disponibles. Además, tienes la opción de contratar canales Premiums de Discovery +, Golden + y Paramount+. </p>
    También puedes alquilar películas cuando tu quieras, los estrenos de cine, también están en XD Neo.
    `
  },
  {
    title: '¿Me puedo cambiar de plan?',
    content: `<p>Claro, puedes cambiarte de plan cuando lo decidas. </p>
    <p>Debes tener en cuenta que con el Plan Básico sólo podrán mirar 2 dispositivos a la vez, mientras que con el Plan Full podrán ver hasta 4.</p>
    Si tienes claro el plan a cambiar es muy fácil, debes ingresar a la página web de XDNeo con tu correo y contraseña y realizar el cambio.
    `
  },
  {
    title: '¿Cómo puedo ver los canales Premiums?',
    content: `<p>Para agregar canales a tu suscripción, ingresa con tu correo electrónico y contraseña a tu cuenta de XDNeo. En la página principal, encontrarás los distintos canales premium que puedes agregar a tu suscripción.</p>
    Recuerda que si tienes una gift card XDNeo puedes utilizarla para tu adquirir tu canal Premium.`
  },
  {
    title: '¿Cómo alquilar películas?',
    content: `<p>Ingresa en el apartado de series y películas, escoge la película de estreno o la que más te guste y dale un clic. </p>
    Te llevará a la página de administración de tu cuenta y podrás procesar el pago. Recuerda que si tienes una gift card XDNeo puedes utilizarla para tu adquirir tu canal Premium.`
  },
  {
    title: '¿Hay promos?',
    content: `<p>Los primeros 7 días de los planes pagos, son gratis. </p>
    Y si referencias a un amigo con tu código, te beneficias con 10 créditos XD para utilizarlos en todos tus consumos.`
  }
];